
$(document).ready(function() {
    $('.youtube, .popup-vimeo').magnificPopup({
        
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,

        fixedContentPos: false
    });
});
$(".tab_contentone").hide();
$(".tab_contentone:first").show();


$("ul.tabsone li").click(function() {
  if ($(this).attr("class") == 'active' || $(this).attr("class") == 'tab_last active') {
    var activeTab = $(this).attr("rel");
    $("#" + activeTab).fadeOut();
    $(this).removeClass("active");
    $(".tab_drawer_heading[rel^='" + activeTab + "']").removeClass("d_active");
  } else {
    $(".tab_contentone").hide();
    var activeTab = $(this).attr("rel");
    $("#" + activeTab).fadeIn();
    $("ul.tabsone li").removeClass("active");
    $(this).addClass("active");

    $(".tab_drawer_heading").removeClass("d_active");
    $(".tab_drawer_heading[rel^='" + activeTab + "']").addClass("d_active");
  }
});

$(".tab_drawer_heading").click(function() {

  $(".tab_contentone").hide();
  var d_activeTab = $(this).attr("rel");
  $("#" + d_activeTab).fadeIn();

  $(".tab_drawer_heading").removeClass("d_active");
  $(this).addClass("d_active");

  $("ul.tabsone li").removeClass("active");
  $("ul.tabsone li[rel^='" + d_activeTab + "']").addClass("active");
});

var acc = document.getElementsByClassName("accordion");
var i;
for (i = 0; i < acc.length; i++) {
 acc[i].onclick = function(){
 this.classList.toggle("active");
 this.nextElementSibling.classList.toggle("show");
};
}
const root = document.documentElement;
const marqueeElementsDisplayed = getComputedStyle(root).getPropertyValue("--marquee-elements-displayed");
const marqueeContent = document.querySelector("ul.marquee-content");

root.style.setProperty("--marquee-elements", marqueeContent.children.length);

for(let i=0; i<marqueeElementsDisplayed; i++) {
  marqueeContent.appendChild(marqueeContent.children[i].cloneNode(true));
}
